import React from 'react';
import { LogoProps } from './types';

function Disk({ width, height, color }: LogoProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.416504 18.7082H15.5832V16.5415H0.416504V18.7082ZM15.5832 6.7915H11.2498V0.291504H4.74984V6.7915H0.416504L7.99984 14.3748L15.5832 6.7915Z"
        fill={color}
      />
    </svg>
  );
}

export default Disk;
